/* 闭环报送接口 */

import { GET, POST, download, uploading, GETNEW, POSTNEW, EXPORTNEW, POSTFormDataNEW, uploadingImg } from '@/request/http'

// 获取咨询师管理的table数据
export const getCounselorManageData = p => POSTNEW('/appointment/appointment/queryTeacherInfo', p)

// 上传图片
export const ImageUploadCounselor = p => uploadingImg('/basic/aliyun-oos/upload-image/counselor', p)

// 获取咨询师列表
export const departmentGetCounselorList = p => POSTNEW('/basic/user/employee/list', p)

// 提交咨询师数据（添加）
export const submitCounselorData = p => POSTNEW('/appointment/appointment/addTeacherInfo', p)

// 提交咨询师数据（修改）
export const submitCounselorDetailData = p => POSTNEW('/appointment/appointment/updateTeacherInfo', p)

// 删除咨询师数据
export const delCounselorDetailData = p => POSTNEW('/appointment/appointment/removeTeacherInfo', p)

// 提交咨询师排班数据（添加）
export const submitCounselorScheduleData = p => POSTNEW('/appointment/appointment/addTeacherSchedule', p)

// 提交咨询师排班数据（修改）
export const submitCounselorScheduleDetailData = p => POSTNEW('/appointment/appointment/updateTeacherSchedule', p)

// 获取咨询师排班列表
export const getCounselorScheduleList = p => POSTNEW('/appointment/appointment/queryTeacherSchedule', p)

// 删除咨询师排班数据
export const delCounselorScheduleDetailData = p => POSTNEW('/appointment/appointment/removeteacherScheduleInfo', p)

// 根据咨询师id和日期获取咨询师时间段列表
export const idAndDategetCounselorScheduleTimeList = p => POSTNEW('/appointment/appointment/queryTeacherScheduleInfo', p)

// 订单查询
export const getCounselorAppointmentList = p => POSTNEW('/appointment/appointment/queryAppOrder', p)

// 订单查询详情
export const getCounselorAppointmentHint = p => POSTNEW('/appointment/appointment/queryOrderInfoByScheduleId', p)

// 取消预约数据
export const cancleSubscribe = p => POSTNEW('/appointment/appointment/cancleAppOrder', p)

// 咨询档案导出
export const counselingExportData = p => EXPORTNEW('/appointment/appointment/exportAppOrder', p)

// 根据orderId获取详情
export const getStudentSubmitSchedulingData = p => POSTNEW('/appointment/appointment/queryOrderRegisterInfo', p)

// 获取问题列表（多选数据）
export const getQuestionList = p => POSTNEW('/appointment/appointment/queryQueInfo', p)

// 提交数据
export const submitSubscribe = p => POSTNEW('/appointment/appointment/submitRegister', p)

// 根据排班id获取学生详情数据
export const queryOrderInfoByScheduleIdToStudentData = p => GETNEW('/appointment/appointment/queryOrderInfoByScheduleId', p)

// 根据orderId获取学生详情数据
export const queryOrderInfoByOrderIdToStudentData = p => GETNEW('/appointment/appointment/queryOrderInfoByOrderId', p)

// 下载学生登记表
export const downloadStudentRegisterData = p => EXPORTNEW('/appointment/visitor-register/get/pdf-url', p, '', 'get')

// 下载学生心理咨询档案
export const psyRecordDownload = p => EXPORTNEW('/appointment/appointment/get-register-pdf', p, '', 'get')

// 根据咨询师id和日期删除数据
export const idanddayDelData = p => POSTNEW('/appointment/appointment/removeTeacherScheduleInfoByAppDay', p)

// 确定数据
export const affirmSubscribe = p => POSTNEW('/appointment/appointment/confirmApp', p)

// 获取指定天的排班记录
export const getAppointDaySchedule  = p => GETNEW('/appointment/appointment/findListByAppDay', p)

// 提交心理干预订单
export const submitPsychologicalInterventionOrder = p => POSTNEW('/appointment/appointment/saveAppMeddle', p)

// 修改咨询模式
export const changeConsultationMode = p => POSTNEW('/appointment/appointment/updateConsultMode', p)

// 获取学生校区
export const getStudentCampus = p => GETNEW('/appointment/appointment/getCampusByFacultyId', p)



// WEBPACK FOOTER //
// ./src/api/modules/counseling.js